<template>
    <svg width="24" height="24" viewBox="0 0 24 24" :fill="fill" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_215_105" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24"/>
        </mask>
        <g mask="url(#mask0_215_105)">
            <path d="M12 18L6 12L7.4 10.6L11 14.2V5H13V14.2L16.6 10.6L18 12L12 18Z"/>
        </g>
    </svg>


</template>

<script>
export default {
    name: "ArrowIcon",
    props: {
        fill: {
            type: String,
            required: false,
            default: "currentColor"
        }
    }
}
</script>
